module.exports = __webpack_public_path__ + "static/media/service1.21d7400c.webp";